import { NgModule } from '@angular/core';
import { ObsidiamJweComponent } from './obsidiam-jwe.component';



@NgModule({
  declarations: [
    ObsidiamJweComponent
  ],
  imports: [
  ],
  exports: [
    ObsidiamJweComponent
  ]
})
export class ObsidiamJweModule { }
